define('viewmodels/pages/login',[
    'knockout',
    'underscore',
    'common/tools',
    'plugins/dialog'
], function (ko, _, tools, dialog) {

    var CHOICE_RESET_PASSWORD = 'resetpassword',
        CHOICE_TRY_AGAIN = 'tryagain';

    /* eslint-disable max-statements */
    return function LoginViewModel (
        loginModel,
        getField,
        navigation,
        vocabulary,
        sessionHistory,
        ChooseAccountDialog,
        ForgotPasswordDialog,
        ChoiceAlert,
        formFields,
        onLoginPageActivated
    ) {
        var self = this,
            loginCommand = loginModel.createCommand(
                function () {
                    navigation.navigate(navigation.ROUTES.PLAYER);
                },
                function (reason, wrongAttemptsCount, shouldShowAccountLockWarning) {
                    if (shouldShowAccountLockWarning) {
                        showAccountLockWarning(wrongAttemptsCount).then(function (choice) {
                            if (choice === CHOICE_RESET_PASSWORD) {
                                self.showForgotPassword();
                            }
                        });
                    }
                    // any other errors are handled as command rejections by the globalCommandListener
                }
            );

        self.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        self.preSelectedAccount = ko.observable();
        self.preSelectedCasumoName = self.preSelectedAccount.property('casumoName');

        self.welcomeBackText = getField('welcome_back_text', { username: self.preSelectedCasumoName });
        self.formInstructionsText = getField('form_instructions');
        self.loginIDFieldLabel = getField('user_field_label');
        self.passwordFieldLabel = getField('password_field_label');
        self.loginButtonText = getField('login_button_text');
        self.wrongCredentialsErrorText = getField('wrong_credentials_error_text');
        self.forgotPasswordLinkText = getField('forgot_password_link_text');
        self.notUserText = getField('not_user_text', { username: self.preSelectedCasumoName });
        self.chooseAccountLinkText = getField('choose_account_link_text');
        self.signUpLinkText = getField('sign_up_link_text');

        self.loginRequiredToPlayText = getField('login_required_to_play_text');
        self.triedToPlayNonFreeplayGame = ko.observable(false);

        self.showLoginRequiredToPlayText = ko.pureComputed(function () {
            return self.triedToPlayNonFreeplayGame() && !!self.preSelectedCasumoName();
        });

        self.loginIDField = formFields.textField(loginModel.user);
        self.passwordField = formFields.passwordField(loginModel.plainTextPassword);

        self.doLogin = function () {
            return loginCommand.dispatch().then(null, function () {});
        };

        self.isWrongCredentials = loginModel.isWrongCredentials;

        self.preSelectedAccount.subscribeAndExec(function (preSelectedAccount) {
            if (preSelectedAccount) {
                loginModel.user(preSelectedAccount.email || preSelectedAccount.casumoName);
            } else {
                loginCommand.reset();
            }
        });

        self.accountHistory = sessionHistory;

        self.activate = function () {
            self.preSelectedAccount(sessionHistory.lastSession());

            if (onLoginPageActivated) {
                onLoginPageActivated();
            }
        };

        self.chooseAccount = function () {
            var self = this;

            dialog.showDialog(new ChooseAccountDialog(getField, this.accountHistory.history))
                .then(function (chosenAccount) {
                    self.preSelectedAccount(chosenAccount);
                });
        };

        self.showForgotPassword = function () {
            dialog.showDialog(new ForgotPasswordDialog(getField, loginModel.user()));
        };

        self.handleNoLoggedOutFreeplay = function () {
            self.triedToPlayNonFreeplayGame(true);
        };

        function showAccountLockWarning (attemptsCount) {
            return (new ChoiceAlert(
                getField('account_block_warning_title'),
                getField('account_block_warning_message', {
                    attempts: attemptsCount,
                    maxAttempts: loginModel.maxAttempts + 1
                }),
                [
                    {
                        id: CHOICE_RESET_PASSWORD,
                        text: getField('reset_password_button_text'), button: 'orange'
                    },
                    {
                        id: CHOICE_TRY_AGAIN,
                        text: getField('try_again_button_text'),
                        button: 'grey-light'
                    }
                ]
            )).show();
        }
    };
    /* eslint-enable max-statements */

});

